const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const setToggleLabel = (toggle, isPlaying) => {
	toggle.hidden = false;
	toggle.textContent = isPlaying ? 'Pause' : 'Play';
};

export const initHeroVideos = (root = document) => {
	root.querySelectorAll('[data-hero-video]').forEach((video) => {
		const toggle = root.querySelector(`[data-hero-video-toggle][aria-controls="${video.id}"]`);
		if (!toggle || toggle.dataset.heroVideoBound === 'true') {
			return;
		}

		toggle.dataset.heroVideoBound = 'true';

		const playVideo = () => {
			const playResult = video.play();
			if (playResult && typeof playResult.then === 'function') {
				playResult.then(() => setToggleLabel(toggle, true)).catch(() => setToggleLabel(toggle, false));
				return;
			}
			setToggleLabel(toggle, !video.paused);
		};

		const pauseVideo = () => {
			video.pause();
			setToggleLabel(toggle, false);
		};

		if (prefersReducedMotion()) {
			pauseVideo();
		} else {
			playVideo();
		}

		toggle.addEventListener('click', () => {
			if (video.paused) {
				playVideo();
				return;
			}
			pauseVideo();
		});
	});
};
